// Message de délai ATTACHÉ à la commande (LOT 7 §2 amendé par l'arbitrage
// cascade 11/07) — composant présentatif UNIQUE partagé T1/Production (interdit :
// implémentations CSS indépendantes qui dériveraient). Sémantique couleurs :
// « À l'heure » neutre ardoise · « Risque de retard » ambre (mix palette) ·
// « En retard de X min » / « Capacité dépassée » rouge (= action requise, jamais
// un accent). Élément MAISON statique — zéro animation (garde-fou Production).
// Aucun statut -> null (prete/terminales : rien, et rien à vide).
import type { StatutDelai as StatutDelaiMoteur } from '@/lib/heure-capacite';

interface Props {
  delai: StatutDelaiMoteur | undefined;
  className?: string;
}

export function StatutDelai({ delai, className = '' }: Props) {
  if (!delai) return null;
  const base = `font-jost ${className}`;
  switch (delai.type) {
    case 'a_l_heure':
      return (
        <span data-testid="statut-delai" data-delai="a_l_heure" className={`${base} text-ardoise`}>
          À l&apos;heure
        </span>
      );
    case 'risque':
      return (
        <span data-testid="statut-delai" data-delai="risque" className={`${base} font-medium text-risque`}>
          Risque de retard
        </span>
      );
    case 'capacite':
      return (
        <span data-testid="statut-delai" data-delai="capacite" className={`${base} font-bold text-destructive`}>
          Capacité dépassée
        </span>
      );
    case 'retard':
      return (
        <span data-testid="statut-delai" data-delai="retard" className={`${base} font-bold text-destructive`}>
          En retard de {delai.retardMin} min
        </span>
      );
  }
}
